<template>
  <div
    class="custom-loader-overlay"
    :class="{ show: overlay, absolute: absolute }"
    :style="getOverlayStyles"
  >
    <div class="custom-loader" :style="getStyles"></div>
  </div>
</template>
<script>
export default {
  name: 'CustomLoader',
  props: {
    size: { type: Number, default: 20 },
    overlay: { type: String, default: '' },
    absolute: { type: Boolean, default: false },
  },
  computed: {
    getStyles() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
      };
    },
    getOverlayStyles() {
      let bgColor = 'transparent';

      if (this.overlay !== '') {
        if (this.overlay === 'dark') {
          bgColor = '#3b3d49d1';
        } else {
          bgColor = this.overlay;
        }
      }

      return {
        backgroundColor: bgColor,
      };
    },
  },
};
</script>
<style scoped>
.custom-loader-overlay {
  height: fit-content;
  width: fit-content;
}
.custom-loader-overlay.show {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-loader-overlay.absolute {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
}

.custom-loader {
  content: ' ';
  display: block;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: loader 1.2s linear infinite;
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
